import styled from 'styled-components';
import { Form } from 'formik';

export const Container = styled.div`
  height: 100%;
  max-height: ${props => props.maxHeight};
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;

  @media (max-width: 425px) {
    max-height: 100%;
  }
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  padding: 10px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const WrapText = styled.div`
  white-space: normal; /* Allow text to wrap */
  word-wrap: break-word; /* Break long words if necessary */
  overflow-wrap: break-word; /* Ensure compatibility with all browsers */
`;

export const FlexButton = styled.button`
  position: fixed;
  bottom: 30px; /* Adjusted position */
  right: 30px; /* Adjusted position */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px; /* Adjusted size */
  height: 60px; /* Adjusted size */
  background-color: #28a745; /* Reverted to the previous green color */
  color: white;
  border: none;
  border-radius: 50%; /* Fully rounded edges for a circular shape */
  font-size: 20px; /* Adjusted font size */
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 1000;

  &:hover {
    background-color: #218838; /* Reverted hover color */
    transform: translateY(-2px);
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); /* Reverted focus color */
  }

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
